// Please sync with packages/frontend/feature-flags/src/FeatureFlagModal.tsx
export enum FeatureFlag {
  /** Permanent (for now) */
  CoinList = 'CoinList' /** Only exists for Drescher */,
  DevTools = 'DevTools',

  /** Feature flag to be enabled to HIDE the feature (inverted semantics) */
  HideCashManagementDeposit = 'HideCashManagementDeposit',
  HideCashManagementTransfer = 'HideCashManagementTransfer',
  PaymentStatusBadge = 'PaymentStatusBadge',
  AddFamilyMember = 'AddFamilyMember',
  AccountingPaymentsNew = 'AccountingPaymentsNew' /** Keep for Caritas until autumn */,
  dev_ServiceProviderApp = 'dev_ServiceProviderApp' /** Keep for Caritas until autumn */,
  ServiceProviderPayments = 'ServiceProviderPayments' /** Keep for Caritas until autumn */,
  ResidentsPaymentOverview = 'ResidentsPaymentOverview' /** Keep for Caritas until autumn */,

  /** Still in development */
  ImportFamilyMembers = 'ImportFamilyMembers',
  EmployeeManagement = 'EmployeeManagement',

  /** Development */
  dev_NursingHomeReceiptForServiceProvider = 'dev_NursingHomeReceiptForServiceProvider',
  dev_PliantTransactions = 'dev_PliantTransactions',
  dev_CaritasManualRoles = 'dev_CaritasManualRoles',

  /** Feature to be removed (Keep for Drescher) */
  AccountingPayments = 'AccountingPayments',

  dev_ServiceProviderPhoenixApi = 'dev_ServiceProviderPhoenixApi',
  dev_StripeVisualization = 'dev_StripeVisualization',
  dev_EmployeeSelector = 'dev_EmployeeSelector',

  dev_ResidentTypeAndWalletModeSelectors = 'dev_ResidentTypeAndWalletModeSelectors',
  dev_InitialBalanceForResident = 'dev_InitialBalanceForResident',
  dev_NationalityAndCountryOfResidenceSelectors = 'dev_NationalityAndCountryOfResidenceSelectors',

  dev_MultiplePayments = 'dev_MultiplePayments',
  dev_ScaEnrollment = 'dev_ScaEnrollment',
  dev_AsyncReceiptBatchSubmission = 'dev_AsyncReceiptBatchSubmission',
  dev_OfflineSepaMandate = 'dev_OfflineSepaMandate',
  dev_OfflineSepaManualPayin = 'dev_OfflineSepaManualPayin',
  dev_DeleteVerifiedFamilyMember = 'dev_DeleteVerifiedFamilyMember',
  dev_ResidentPdfReceiptImages = 'dev_ResidentPdfReceiptImages',
  dev_ResidentLevelAccess = 'dev_ResidentLevelAccess',

  /** Expense management */
  ExpenseManagement = 'ExpenseManagement',
  ReceiptManagement = 'ReceiptManagement',
}

export enum FeatureFlagStatus {
  Disabled,
  Enabled,
}
